module.exports = __webpack_public_path__ + "img/banner3.fd934845.png";